import {
  ApplicationConfig,
  inject,
  isDevMode,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideNzIcons } from './icons-provider';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTransloco, translocoConfig } from '@jsverse/transloco';
import { apiInterceptor } from './services/apis/api.interceptor';
import { AppInitService } from './services/app-init.service';
import { I18nService } from './core/i18n/i18n.service';
import { TranslocoHttpLoader } from './core/i18n/transloco-loader';
import { AVAILABLE_LANGS } from './core/i18n/i18n.config';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';

registerLocaleData(en);
registerLocaleData(zh);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(async () => {
      await inject(AppInitService).init();
    }),
    provideAppInitializer(async () => {
      await inject(I18nService).init();
    }),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideNzIcons(),
    provideNzI18n(en_US),
    provideTransloco({
      config: translocoConfig({
        availableLangs: [...AVAILABLE_LANGS],
        defaultLang: 'en-US',
        fallbackLang: 'en-US',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      }),
      loader: TranslocoHttpLoader,
    }),
    provideHttpClient(withInterceptors([apiInterceptor])),
    provideNzDateFnsAdapter(),
  ],
};
